<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" v-esc="escape">
    <div class="w-full" @keyup.enter="submitData">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Ödeme Tipi" : "Ödeme Tipi Düzenle" }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <form data-vv-scope="form-1">
          <div class="px-6 pt-6">

            <vs-input id="name" name="İsim" v-validate="'required|min:2|max:40'" v-model="newPaymentMethod.name" class="w-full"
              icon-pack="feather" icon="icon-user" label-placeholder="Ödeme Tipi İsmi" />
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.İsim')">{{ errors.first('form-1.İsim') }}</span>

            <v-select id="originPaymentMethod" name="Ana Ödeme Tipi" v-validate="'required'" :clearable="false"
              v-model="newPaymentMethod.originPaymentMethod" itemid="id" label="name" placeholder="Ana Ödeme Tipi Seçimi.."
              :options="availablePaymentMethods" class="mt-4">
            </v-select>
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.Ana Ödeme Tipi')">{{ errors.first('form-1.Ana Ödeme Tipi') }}</span>

          </div>
        </form>
        <div class="flex mt-5 px-6 pb-4">
          <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
            Vazgeç
          </vs-button>
          <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {
    createNewPaymentMethod,
    updatePaymentMethod
  } from '@/api/PaymentMethod';
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {
      return {
        paymentMethodValues : [
          "Pozifif","Negatif","Nötr"
        ],
        newPaymentMethod: {},
        paymentMethods : [],
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
            this.$validator.reset()
            this.initValues()
          }
        }
      },
      availablePaymentMethods(){
        return this.paymentMethods.filter(x=> x.type == 'SolidRoot')
      }
    },
    methods: {
      escape(){
        if(this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
      },
      initValues: function () {
        this.newPaymentMethod = {};
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll('form-1');
        if (checker) {
          if (this.newPaymentMethod.id) {
            updatePaymentMethod(this.newPaymentMethod).then(res => {
              if (res && res.status === 200) {
                let paymentMethodIndex = this.paymentMethods.findIndex((p) => p.id == res.data.id)
                Object.assign(this.paymentMethods[paymentMethodIndex], res.data);
                this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Ödeme Tipi Güncelleme İşlemi Başarılı !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Ödeme Tipi Güncelleme İşlemi Başarısız !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          } else {
            this.newPaymentMethod.id = 0;
            createNewPaymentMethod(this.newPaymentMethod).then(res => {
              if (res && res.status === 200) {
                this.paymentMethods.unshift(res.data);
                this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Ödeme Tipi Ekleme İşlemi Başarılı !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Ödeme Tipi Ekleme İşlemi Başarısız ! '
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası ! '
              });
            });
          }
        }
      },
      mapNewUnit: async function () {
        //map
      },
    },
    components: {
      VuePerfectScrollbar
    },
    watch: {
      isSidebarActive: function (val) {
        if (!val) return;
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.newPaymentMethod = _.cloneDeep(this.data);
        }
      }
    },
    mounted: function () {},
    created: function () {}
  }

</script>

<style lang="scss" scoped>
  .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: red;
    text-transform: lowercase;
    font-variant: small-caps;
  }

  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }

</style>
